import React from 'react';
import { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { ActiveDotCell } from '../shared';
import { Company, OrderProduct, User } from '../../models';

interface ErrorQRProps {
  client: Partial<User>;
  partner: Partial<Company>;
  discountCode: string;
  isOnline: boolean;
  isUsed: boolean;
  onTrade: () => Promise<void>;
  refetch?: (variables?: Partial<OperationVariables>) => Promise<
    ApolloQueryResult<{
      getOrderProductById: OrderProduct;
    }>
  >;
}

function TradeInfo({
  client,
  partner,
  discountCode,
  isOnline,
  isUsed,
  onTrade,
  refetch,
}: ErrorQRProps) {
  const onClickTrade = async () => {
    await onTrade();
    await refetch();
  };
  return (
    <div className="bg-white shadow-md rounded-md p-3 md:p-6">
      <h2 className="text-purple-300 text-xl font-semibold mb-4 border-b pb-2">
        Información del cliente
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-5">
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Nombre:</p>
          <span className="font-medium text-gray-900">{client?.firstName}</span>
        </div>
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Cédula:</p>
          <span className="font-medium text-gray-900">
            {client?.dni.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
          </span>
        </div>
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Correo electrónico:</p>
          <span className="font-medium text-gray-900">{client?.email}</span>
        </div>
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Teléfono:</p>
          <span className="font-medium text-gray-900">
            +{client.phone.slice(0, 2)} {client.phone.slice(2, 5)}.
            {client.phone.slice(5, 8)}.{client.phone.slice(8)}
          </span>
        </div>
      </div>

      <h2 className="text-purple-300 text-xl font-semibold mb-4 border-b pb-2">
        Información del aliado
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Nombre:</p>
          <span className="font-medium text-gray-900">{partner.name}</span>
        </div>
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Teléfono:</p>
          <span className="font-medium text-gray-900">
            +{partner.phone.slice(0, 2)} {partner.phone.slice(2, 5)}.
            {partner.phone.slice(5, 8)}.{partner.phone.slice(8)}
          </span>
        </div>
        <div>
          <p className="text-purple-300 font-semibold">
            Código de descuento usado:
          </p>
          <span className="font-medium text-gray-900">{discountCode}</span>
        </div>
        <div className=" p-2 rounded-md">
          <p className="text-purple-300 font-semibold">Correo:</p>
          <span className="font-medium text-gray-900">{partner.email}</span>
        </div>
        <div className=" p-2 rounded-md">
          <ActiveDotCell active={partner.active} />
        </div>
        {!isOnline && !isUsed ? (
          <div className="flex flex-row justify-end items-center m-2">
            <button
              type="button"
              className="py-2 rounded tracking-wide transition-colors w-fit whitespace-nowrap px-10 bg-purple-300 text-system-100 hover:bg-color-primary-200 font-normal border-0"
              onClick={(e) => {
                e.preventDefault();
                onClickTrade();
              }}
            >
              Canjear
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default TradeInfo;
